// extracted by mini-css-extract-plugin
export default {"page":"Nh-z","cartModal":"Oh-z","checkout":"Ph-z","placeholder":"Qh-z","account":"Rh-z"};